export default "__VITE_ASSET__dea25f3b__"